export default __webpack_public_path__ + "static/media/logo_small.bb1de3a9.svg";